import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { generatePath, Link } from 'react-router-dom'
import { TASKS_ALL_NAMESPACE, useWorkspaceTasks } from 'screens/Todos/hooks/useWorkspaceTasks'
import Styles from './Tasks.module.scss'
import { Counter, CounterVariant } from 'blaze-ui/Counter/Counter'
import { getTotalCountFromInfiniteQuery } from 'utils/query'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'
import { TODOS_PATH } from 'paths'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

export const Tasks = ({ onClose }: { onClose: () => void }) => {
  const currentWorkspace = useCurrentWorkspace()
  const allTodosAssignedQuery = useWorkspaceTasks({
    namespace: TASKS_ALL_NAMESPACE,
    workspaceId: currentWorkspace?.key,
    filters: { request_state: 'open', types: [], role: 'assignee', review_state: 'pending', todo_state: 'incomplete' },
    items: 1,
  })
  const count = getTotalCountFromInfiniteQuery(allTodosAssignedQuery)

  if (!count) return null

  return (
    <div className={Styles.tasksContainer}>
      <div className={Styles.count}>
        <Counter variant={CounterVariant.Dark} count={count} />
        <Text variant="smallList" color="var(--dark-80)">{`${pluralize('Task', count)} ${
          count > 1 ? 'are' : 'is'
        } assigned to you`}</Text>
      </div>
      <ButtonLink
        to={generatePath(TODOS_PATH, { workspaceId: currentWorkspace?.id })}
        elementType={Link}
        onPress={() => {
          setTimeout(() => onClose(), 0)
        }}
        variant="secondary"
        size="sm"
      >
        Open Tasks
      </ButtonLink>
    </div>
  )
}
